'use client';

import styles from './index.module.scss';
import { serviceCategories } from './data';
import { useState } from 'react';

export default function ProServicesDetailSection() {
  const [expandedIndex, setExpandedIndex] = useState(0);

  const toggleCategory = (index) => {
    setExpandedIndex(expandedIndex === index ? -1 : index);
  };

  return (
    <section className={styles.container} id="pro-services">
      <div className="container-wrapper">
        <div className={styles.header}>
          <div className={styles.badge}>Our PRO Services</div>
          <h2 className={styles.title}>Comprehensive PRO Support</h2>
          <p className={styles.description}>
            Our comprehensive PRO services are designed to support professionals, entrepreneurs, and SMEs across all industries. From residence visas and Emirates ID processing to document attestation and translation services, Ninjaz provides end-to-end PRO support—regardless of where your trade license was originally issued.
          </p>
        </div>

        <div className={styles.categories}>
          {serviceCategories.map((category, catIndex) => (
            <div
              key={catIndex}
              className={`${styles.category} ${expandedIndex === catIndex ? styles.expanded : ''}`}
            >
              <button
                className={styles.categoryHeader}
                onClick={() => toggleCategory(catIndex)}
                aria-expanded={expandedIndex === catIndex}
              >
                <div className={styles.categoryTitleWrapper}>
                  <div className={styles.categoryIcon}>
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                  </div>
                  <h3 className={styles.categoryTitle}>{category.title}</h3>
                </div>
                <svg
                  className={styles.chevron}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <div className={styles.categoryContent}>
                <div className={styles.servicesList}>
                  {category.services.map((service, srvIndex) => (
                    <div key={srvIndex} className={styles.serviceItem}>
                      <div className={styles.serviceDot} />
                      <div>
                        <h4 className={styles.serviceName}>{service.name}</h4>
                        <p className={styles.serviceDescription}>{service.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
